module.exports = __webpack_public_path__ + "img/4_164.4052d9c2.png";